import {Component, OnInit} from '@angular/core';
import {ViewportScroller} from "@angular/common";
import {ActivatedRoute} from "@angular/router";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {EventDetail} from "@biletix/core/models/event/event-detail.model"; 
import {TabItem} from "@biletix/core/view-models/tab-item.view.model";
import {MatDialog} from "@angular/material/dialog";
import {EventPageStateService} from "@biletix/features/event/services/event-page-state.service";
import {TranslateService} from "@ngx-translate/core";


@Component({
    standalone: false,
    selector: 'btx-event-page-tab-menu',
    templateUrl: './event-page-tab-menu.component.html',
    styleUrls: ['./event-page-tab-menu.component.scss']
})
export class EventPageTabMenuComponent extends AbstractionComponent implements OnInit {


    eventDetail: EventDetail | any;


    links: TabItem[] = [
        {label: 'performance.labels.about',anchor: 'about'},
        {label: 'performance.labels.eventsList', anchor: 'eventsList'},
        {label: 'performance.labels.rules', anchor: 'rules'}
    ];

    activeLink = this.links[0];

    constructor(private  viewScroller: ViewportScroller,
                private activatedRoute: ActivatedRoute,
                private eventPageStateService: EventPageStateService,
                private translate: TranslateService,
                private dialog: MatDialog) {
        super();


        //get current event detail
        this.eventDetail = this.eventPageStateService.getCurrentEventDetail();
    }

    ngOnInit(): void {
        this.createTabMenuLinks();
    }

    initFragment() {
        let fragment: string | any = this.activatedRoute.snapshot.fragment;
        const currentLink = this.links
            .filter(item => item.anchor != null)
            .find(item => item.anchor == fragment);

        if (currentLink) {
            this.activeLink = currentLink;
            this.scrollToAnchor(fragment);
        }
    }

    createTabMenuLinks() {
        // if (this.eventDetail.eventRules && this.eventDetail.eventRules.length > 0){
        //     this.links.push({label: 'performance.labels.rules', anchor: 'rules'})
        // }


        // this.links.push(
        //     {label: 'performance.labels.reviews', labelParams: {size: 0}, anchor: 'reviews'}
        // );

      if (this.eventDetail.groupSaleDetailInfo) {
        this.links.push({label: 'performance.labels.groupSale', href: this.translate.instant('performance.links.groupSaleLink')});
      }
    }

    onClickTabItem(link: TabItem) {
        this.activeLink = link;

        if (link.anchor) {
            this.scrollToAnchor(link.anchor);
        }

        if (link.dialog) {
            this.openModal(link.component);
        }

      if (link.href) {
        window.open(link.href, '_blank');
      }
    }

    openModal(component: any) {
        this.dialog.open(component, {
                width: '100%',
                maxWidth: '1220px'
            }
        );
    }

    scrollToAnchor(anchor: string) {
        this.viewScroller.scrollToAnchor(anchor);
    }
}
